import { Modal } from 'antd';

/**
 * Asks the operator whether the carrier's justification (category, notes,
 * attachments) must be removed while resetting penalties to PENDING.
 *
 * Resolves true only when "Yes, remove it" is pressed. "No, keep it", the
 * close icon, Escape and any other dismissal resolve false: keeping the
 * justification is the default.
 */
const confirmRemoveJustification = (
  justifiedCount: number,
  total: number,
): Promise<boolean> => {
  const subject =
    total === 1
      ? 'This penalty carries a justification from the carrier'
      : `${justifiedCount} of the ${total} selected penalties carry a justification from the carrier`;

  return new Promise(resolve => {
    Modal.confirm({
      title: "Remove the carrier's justification?",
      content: (
        <>
          <p>{subject} (category, notes, attachments).</p>
          <p>Resetting to PENDING keeps it unless you choose to remove it.</p>
        </>
      ),
      centered: true,
      okText: 'Yes, remove it',
      okButtonProps: { danger: true },
      cancelText: 'No, keep it',
      autoFocusButton: 'cancel',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
};

export default confirmRemoveJustification;
